document.addEventListener('DOMContentLoaded', function() {
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function() {
      navbar.classList.toggle('scrolled', window.scrollY > 80);
    });
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); }
    });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
  document.querySelectorAll('.step').forEach(function(s) {
    s.addEventListener('click', function() {
      document.querySelectorAll('.step').forEach(function(x) { x.classList.remove('on'); });
      s.classList.add('on');
    });
  });
  document.querySelectorAll('.fbtn').forEach(function(b) {
    b.addEventListener('click', function() {
      document.querySelectorAll('.fbtn').forEach(function(x) { x.classList.remove('on'); });
      b.classList.add('on');
    });
  });
  var testiItems = document.querySelectorAll('.ti');
  var testiDots = document.querySelectorAll('.dot');
  var activeT = 0;
  function setTesti(n) {
    activeT = n;
    testiItems.forEach(function(e, i) { e.classList.toggle('on', i === n); });
    testiDots.forEach(function(e, i) { e.classList.toggle('on', i === n); });
  }
  testiDots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { setTesti(i); });
  });
  if (testiItems.length > 0) {
    setInterval(function() { setTesti((activeT + 1) % testiItems.length); }, 5000);
  }
});
